import React, { useCallback } from 'react';

import * as actions from '../../containers/DesktopApplication/desktopApplicationActions';
import { DESKTOP_MESSAGING_SERVICES_FIELDS } from '../../common/fields';

import ArrayContainer from '../Controls/ArrayContainer/ArrayContainer';
import MessagingService from './MessagingService';
import Button from '../Controls/Button/Button';

const { MESSAGING_SERVICES } = DESKTOP_MESSAGING_SERVICES_FIELDS;

const DesktopMessagingServices = ({ fields, dispatch }) => {
    const messagingServices = fields[MESSAGING_SERVICES.ID];

    const dispatchAddService = useCallback(() => {
        dispatch({ type: actions.ADD_MESSAGING_SERVICE });
    }, [dispatch]);

    const dispatchUpdateService = useCallback(
        (index, fieldId, value) => {
            dispatch({
                type: actions.UPDATE_MESSAGING_SERVICE,
                payload: { index, arrFieldId: fieldId, value }
            });
        },
        [dispatch]
    );

    const dispatchRemoveService = useCallback(
        (index) => {
            dispatch({ type: actions.REMOVE_MESSAGING_SERVICE, payload: index });
        },
        [dispatch]
    );

    return (
        <>
            {messagingServices.value.map((messagingService, index) => {
                return (
                    <ArrayContainer
                        key={DESKTOP_MESSAGING_SERVICES_FIELDS.MESSAGING_SERVICES.ID + index}
                        header="Messaging Service"
                        remove={() => dispatchRemoveService(index)}>
                        <MessagingService
                            messagingService={messagingService}
                            changedFunc={(fId, v) => dispatchUpdateService(index, fId, v)}
                        />
                    </ArrayContainer>
                );
            })}

            <Button
                id="desktop-messaging-services-add-desktop-messaging-service-btn"
                style={{ marginTop: `${messagingServices.value.length === 0 ? '30px' : '0'}` }}
                onClick={dispatchAddService}>
                + Add Desktop Messaging Service
            </Button>
        </>
    );
};

export default DesktopMessagingServices;
